import { useMemo } from 'react';
import { Select, SelectOption as SelectOptionDS } from '@shape-ds/components';
import { dayjs } from 'lib/dayjs';
import { useRertDate } from 'pages/Reports/Rert/RertDateProvider';

const MONTHS_TO_SHOW = 12;

export function getAllMonths(format = 'MMM/YY'): SelectOptionDS[] {
  const baseDatesArray = new Array(MONTHS_TO_SHOW).fill('');
  return baseDatesArray.map((_, index) => {
    const monthDate = dayjs().subtract(index, 'M');
    const formattedMonth = monthDate.format(format);

    return { label: formattedMonth, value: formattedMonth };
  });
}

export function DateSelect() {
  const { date, setDate } = useRertDate();

  const dates = useMemo(getAllMonths, []);

  return (
    <Select
      value={date.format('MMM/YY')}
      placeholder="Date"
      onChange={(e) => setDate(dayjs(e.target.value as string, 'MMM/YY'))}
      data={dates}
    />
  );
}
